import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchTemplate, fetchTemplates, updateTemplate, createTemplate } from "../../actions/roblox/templatesActions";

export interface TemplateInterface {
  url: string;

  id: number;
  type_id: number;

  coins: number;
  premium: boolean;

  texture_url: string;
  thumbnail_url: string;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;

  newParams: TemplateInterface | undefined;
  newError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null,

  newParams: undefined,
  newError: null
};

const adaptor = createEntityAdapter<TemplateInterface>();

const slice = createSlice({
  name: 'templates',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setNewParams: (state, action) => {
      state.newParams = action.payload;
      state.newError  = initialState.newError;
    },
    setNewError: (state, action) => {
      state.newError = action.payload;
    },
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchTemplates.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.templates;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        const template = Object.values(action.payload.template)[0];
        state.entities[template.id] = template;
      })

      // #create
      .addCase(createTemplate.fulfilled, (state, action) => {
        const template = Object.values(action.payload.template)[0];
        state.entities[template.id] = template;
      })
      .addCase(createTemplate.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.newError = error || action.error.message || 'Unknown Error';
      })

      // #update
      .addCase(updateTemplate.fulfilled, (state, action) => {
        const template = Object.values(action.payload.template)[0];
        state.entities[template.id] = template;
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setNewParams,
  setNewError,
  setEditError
} = slice.actions;

export const {
  selectById: selectTemplateById,
  selectIds: selectTemplateIds,
  selectEntities: selectTemplateEntities,
  selectAll: selectAllTemplates,
  selectTotal: selectTotalTemplates
} = adaptor.getSelectors<RootState>(state => state.roblox.templates);
